import React from "react";
import { useIsMobile } from "../../../../Hooks";
import { MenuMobile } from "./MenuMobile";
import { MenuDesktop } from "./MenuDesktop";

export const MenuSection = () => {
	const isMobile = useIsMobile();

	return <div className="header-action header-menu">{isMobile ? <MenuMobile /> : <MenuDesktop />}</div>;
};
